__turbopack_context__.v({
  "copyCol": "jqU2gG_copyCol",
  "copySlot": "jqU2gG_copySlot",
  "eyebrow": "jqU2gG_eyebrow",
  "imageCol": "jqU2gG_imageCol",
  "imageDesktop": "jqU2gG_imageDesktop",
  "imageMobile": "jqU2gG_imageMobile",
  "lede": "jqU2gG_lede",
  "page": "jqU2gG_page",
  "title": "jqU2gG_title",
});
